import React from 'react';
import { UIWindowModal } from '../modals';
import { useLang } from '../../../_LangContext';
import Utils from '../../../_Utils';

const ModalMenuAlert = ({ isOpen, onClose, messageData, icon = 0 }) => {
    const { lang } = useLang();

    return (
        <UIWindowModal className='alert' isOpen={isOpen} onClose={onClose}>
            <div className="modal-container">
                <div className="modal-container-inner">
                    <div className="alert-content">
                        {icon === 1 && (
                            <div className="alert-icon">
                                <p className="icon exclamation" />
                            </div>
                        )}
                        {messageData && (
                            <div className="message" dangerouslySetInnerHTML={{ __html: Utils.toBR(messageData) }} />
                        )}
                    </div>
                </div>
            </div>
        </UIWindowModal>
    );
};

export default ModalMenuAlert;